
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 61 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M50.5 16.667V10h-6.667v4c0 1.467-1.2 2.667-2.666 2.667H19.833A2.674 2.674 0 0117.167 14v-4H10.5v6.667c0 .68.107 1.346.293 1.973v.013c.854 2.707 3.387 4.68 6.374 4.68h26.666c2.987 0 5.52-1.973 6.374-4.68v-.013a6.93 6.93 0 00.293-1.973zm-3.84 20L50.5 30H39.473l-3.853 6.667-3.84 6.666h-2.56v-.013l-3.84-6.653L21.527 30H10.5l3.853 6.667h3.334L24.66 50h11.68l7.213-13.333h3.107z","fill":"currentColor"}})])
          )
        }
      }
    